import React from 'react';
import { UserContext } from '../../context';
import validator from 'validator';
import {
    FETCH_GENERATED_USERNAME,
    TEMPTED_ACCOUNTS_URL,
} from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';
import Alert from '../../components/generalComponents/Alert';

import './css/ManageAccount.css';
import { AccountTabs } from "./AccountTabs";
import PasswordChangeSection from './PasswordChangeSection';

class ManageAccountPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAlertVisible: false,
            password: '',
            confirmPassword: '',
            email: '',
            content: '',
            nickname: '',
            passwordErrorVisible: false,
            passwordError: '',
            nicknameUpdateCounter: 0
        };
    }
    componentDidMount() {
        const { user } = this.props;
        if (user.user && user.user.account) {
            this.setState({
                email: user.user.account.email,
                nickname: user.user.account.nickname,
                nicknameUpdateCounter: user.user.account.nicknameUpdateCounter ? user.user.account.nicknameUpdateCounter : 0, /* Made this change because the default value for nicknameUpdateCounter is undefined from Backend. */
            })
        }
    }
    showAlert = content => {
        this.setState({
            isAlertVisible: true,
            content
        });
    };
    hideAlert = () => {
        this.setState({
            isAlertVisible: false,
            content: ''
        });
    };
    handleChange = name => e => {
        this.setState({
            [name]: e.target.value,
            isAlertVisible: false
        });
    };

    newPasswordValid = () => {
        const { password } = this.state;
        if (!password) return false;
        const username = sessionStorage.getItem('username');
        const trimmedPassword = password.trim();
        let error = '';
        if (!validator.isLength(trimmedPassword, { min: 8 })) {
            error = "Password needs to be at least 8 characters long and shouldn't contain spaces"
        } else if (trimmedPassword === username) {
            error = 'Password must be different than your username'
        } else if (trimmedPassword.substring(0, 9) === 'nakednews' || trimmedPassword.substring(0, 8) === 'password') {
            error = "Password shouldn't start with 'nakednews' or 'password'"
        }

        if (error) {
            this.setState({
                passwordErrorVisible: true,
                passwordError: error
            })

            return false;
        }
        return true;
    }

    handleSubmit = (e) => {
        //Added nicknameUpdateCounter and user prop here
        const { user } = this.props;
        const { email, password, confirmPassword, nickname, nicknameUpdateCounter } = this.state;
        let data = {};
        data.username = sessionStorage.getItem('username');
        e.preventDefault();
        if (email) {
            data.email = email.trim();
        }
        if (nickname) {
            data.nickname = nickname;
        }
        const trimmedPassword = password && password.trim();
        const trimmedConfirmPassword = confirmPassword && confirmPassword.trim();
        if (trimmedPassword && !this.newPasswordValid()) return;
        if (trimmedPassword) {
            if (trimmedPassword === trimmedConfirmPassword) {
                data.password = trimmedPassword;
            } else {
                this.setState({
                    isAlertVisible: true,
                    content: 'Passwords must match'
                });
                return;
            }
        }

        //Function to handle Nickname change event | Only make calls to tempted if nickname changes and if the user is not an anchor
        const handleNicknameChanges = (nicknameUpdateCounter) => {
            const [defaultNickname, domainName] = email.split("@");
            if (nicknameUpdateCounter === 0 && nickname !== defaultNickname && !user.user.account.anchor) {
                callApi(TEMPTED_ACCOUNTS_URL, 'PUT', false, data, true, true, true, true)
            }
        }

        callApi(FETCH_GENERATED_USERNAME, 'PATCH', false, data, true, true)
            .then(handleNicknameChanges(nicknameUpdateCounter)) //Calls nicknameChange handler function
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        isAlertVisible: true,
                        content: 'Settings are saved'
                    });
                    window.location.reload();
                }
            })
            .catch(err => console.log(err));
    };

    render() {
        const {
            password,
            confirmPassword,
            email,
            nickname,
            isAlertVisible,
            content,
            passwordErrorVisible,
            passwordError,
            nicknameUpdateCounter,
        } = this.state;
        const { user } = this.props;
        const isAnchor = !!user.user.account.anchor;
        const isWhitelisted = user.user ? user.features.includes('ANCHOR_PORTAL') : false;
        const isCam4User = user?.user?.account?.site === 'CAM4';

        return (
            <div className="content flex-1">
                {isAlertVisible && (
                    <Alert onClose={this.hideAlert}>{content}</Alert>

                )}
                <div className="container">
                    <AccountTabs active='/account' />

                    <h1>Your Naked News Account</h1>
                    <form
                        noValidate="novalidate"
                        className="formtastic form-horizontal customer"
                        id="edit_customer_156374"
                        acceptCharset="UTF-8"
                        onSubmit={this.handleSubmit}
                    >
                        <fieldset>
                            <legend>
                                <span>Account Information</span>
                            </legend>
                            <PasswordChangeSection
                                    isCam4User={isCam4User}
                                    handleChange={this.handleChange}
                                    email={email}
                                    password={password}
                                    passwordError={passwordError}
                                    passwordErrorVisible={passwordErrorVisible}
                                    confirmPassword={confirmPassword}
              />
                            <div
                                className="string input optional stringish form-group"
                                id="customer_email_input"
                            >
                                <label
                                    htmlFor="customer_email"
                                    className="control-label"
                                >
                                    Email Address
                                </label>
                                <div>
                                    <input
                                        className="form-control"
                                        placeholder="Email"
                                        id="customer_email"
                                        type="text"
                                        name="customer[email]"
                                        value={email}
                                        onChange={this.handleChange('email')}
                                        disabled
                                    />
                                </div>
                            </div>
                            {isWhitelisted && !isAnchor &&
                                <div
                                    className="string input optional stringish form-group"
                                    id="customer_nickname_input"
                                >
                                    <label
                                        htmlFor="customer_nickname"
                                        className="control-label"
                                    >
                                        Nickname (maximum 12 characters)
                                    </label>
                                    <div>
                                        <input
                                            className="form-control"
                                            placeholder="Set a nickname"
                                            id="customer_nickname"
                                            type="text"
                                            name="customer[nickname]"
                                            value={nickname}
                                            disabled={nicknameUpdateCounter > 0}
                                            maxLength={12}
                                            onChange={this.handleChange('nickname')}
                                        />
                                    </div>
                                </div>
                            }
                        </fieldset>
                        <div className="form-group">
                            <div>
                                <button
                                    name="button"
                                    type="submit"
                                    className="btn btn-danger"
                                    id="customer_submit_action"
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

ManageAccountPage.contextType = UserContext;
export default ManageAccountPage;
